import PATH from '../paths';

const name = 'Genius University';
const key = 'geniusu';
const imgUrl = `${ PATH.CDN }/whitelabels/${ key }`;
const images = {
  favicon: `${ imgUrl }/favicon.ico`,
  logo: `${ imgUrl }/logo.png`,
  logoSidebar: `${ imgUrl }/logo.png`,
  logoPDF: `${ imgUrl }/logo-pdf.png`,
  opengraph: false,
  backgrounds: [
    `${ imgUrl }/bg.png`
  ],
};

export default {

  name,
  key,
  images,
  stylesheet: `
    /* COLOR VARIABLES +++++++++++++++++++++++++++++++++++++++++++++++++++++  */


    --color-primary:                  #022b42;
    --color-secondary:                #06161e;
    --color-accent-green:             #88c040;
    --color-accent-orange:            #de5d28;
    --color-accent:                   var(--color-accent-green);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* TYPOGRAPHY ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    --color-link:                     var(--color-accent-green);
    --color-link-hover:               var(--color-secondary);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
    
    /* LAYOUTS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* ANONYMOUS LAYOUT */

    --anonymous-logo-bg:              var(--color-secondary);
    --anonymous-copy-bg:              var(--color-secondary);
    --anonymous-heading-color:        var(--color-accent-green);
    --anonymous-subheading-color:     var(--color);
    --anonymous-text-color            var(--color-white);
    --anonymous-logo-height:          50px;
    --anonymous-bg:                   url(${ images.backgrounds[0] });
    --anonymous-bg-size:              cover;

    /* END */

    /* SIDEBAR */

    --sidebar-bg-color: var(--color-primary);
    --sidebar-logo-bg-color: var(--color-secondary);
    --sidebar-logo-height: 45px;
    --sidebar-label-color: rgba(var(--color-white-rgb), 0.7);
    --sidebar-border-color: var(--color-accent-green);

    --sidebar-button-color: var(--color-accent);
    --sidebar-button-color-active: var(--color-secondary);
    --sidebar-button-color-hover: var(--color-secondary);
    --sidebar-button-bg-color: transparent;
    --sidebar-button-bg-color-active: var(--color-accent);
    --sidebar-button-bg-color-hover: var(--color-accent);
    --sidebar-button-border-color: var(--color-accent);
    --sidebar-button-border-color-active: var(--color-accent);
    --sidebar-button-border-color-hover: var(--color-accent);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* BUTTONS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* PRIMARY BUTTON */

    --btn-primary--bg:                var(--color-secondary);
    --btn-primary--border:            var(--color-secondary);
    --btn-primary--color:             var(--color-accent);
    --btn-primary--colorH:            var(--color-secondary);
    --btn-primary--bgH:               var(--color-accent);
    --btn-primary--borderH:           var(--color-accent);

    /* END */

    /* SECONDARY BUTTON */

    --btn-secondary--bg:              transparent;
    --btn-secondary--border:          var(--color-accent);
    --btn-secondary--color:           var(--color-secondary);
    --btn-secondary--bgH:             transparent;
    --btn-secondary--borderH:         var(--color-accent);
    --btn-secondary--colorH:          var(--color-accent);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
  `,
  
};
